'use client';

import { Dispatch, SetStateAction, useEffect } from 'react';
import { ModalState } from '../../models';
import { ModalContentWrapper, ModalTitleWrapper } from '../common/Modal';
import { CloseSVG } from '../styled/Close';
import { initialModalState } from '../../models/modal';
import { smartCaptchaYandexScriptUrl } from '../../utils/consts';

export function CaptchaModal({
  setModalState,
}: {
  setModalState: Dispatch<SetStateAction<ModalState>>;
}) {
  useEffect(() => {
    const captchaScript = document.createElement('script');
    captchaScript.setAttribute('src', smartCaptchaYandexScriptUrl);
    captchaScript.setAttribute('id', 'captcha-script');
    document.head.appendChild(captchaScript);
  }, []);

  return (
    <ModalContentWrapper>
      <div>
        <ModalTitleWrapper
          setModalState={setModalState}
          customClose={
            <CloseSVG
              onClick={() => setModalState(initialModalState)}
              css={{ width: 20, height: 20 }}
            />
          }
        />
      </div>
      <div css={{ padding: '0 30px 30px 30px' }}>
        <div
          id='captcha-container'
          className='smart-captcha'
          data-sitekey='ysc1_KVkwjUyKmMF4cuEMAqHqWCKyDwdipjleryCwEwor0abcfd95'
          css={{ height: 106 }}
        />
      </div>
    </ModalContentWrapper>
  );
}
